import * as React from 'react';

import { FetchJson } from '@volkswagen-onehub/fetch-json';

import { useSafeContext } from '../utils/use-safe-context';

export const FetchJsonContext = React.createContext<FetchJson | undefined>(undefined);

export function useFetchJson(): FetchJson {
	return useSafeContext(FetchJsonContext, 'fetchJson');
}
